import { ExamWritingSectionId } from '../../commonv3/types/courseExams';
import { ExamWritingSectionShowView } from '../types/exam_sections';
import { CommonsV1ApiBase } from './base';

export const ExamWritingSectionApis = {
  show(id: ExamWritingSectionId): Promise<ExamWritingSectionShowView> {
    return CommonsV1ApiBase.appendPath('exam_writing_sections/:id').bind({ id }).get();
  },
};
